import React from "react";
import { ordersApi, type ApiOrder, type ApiOrderFilter } from "@src/api/orders";
import { BusinessSearchSelect, type BusinessSearchSelectProps } from "../BusinessSearchSelect";
import { PickerOptionCard } from "@src/shared/ui";

export type OrderSearchSelectProps = Omit<
    BusinessSearchSelectProps<ApiOrder, number>,
    "queryKeyBase" | "loadOptions" | "loadById" | "getId" | "getOptionLabel" | "getSelectedLabel"
> & {
    /** Доп. фильтр API. */
    flt?: ApiOrderFilter;
};

/**
 * SearchSelect заказов.
 */
export function OrderSearchSelect({
    label = "Заказ",
    flt,
    minSearchLength = 1,
    debounceDelay = 500,
    searchPlaceholder = "Номер заказа",
    optionSlots,
    ...rest
}: OrderSearchSelectProps) {
    return (
        <BusinessSearchSelect<ApiOrder, number>
            queryKeyBase={["searchSelect", "order", flt]}
            loadOptions={async (query) => {
                return ordersApi.load({
                    flt: {
                        ...flt,
                        Num: query,
                        ShortNum: query,
                    },
                });
            }}
            loadById={async (code) => {
                const items = await ordersApi.load({
                    flt: { ...flt, Codes: [code] },
                });
                return items[0] ?? null;
            }}
            getId={(item) => item.Code}
            getOptionLabel={(item) => item.Num}
            getSelectedLabel={(item) => item.Num}
            label={label}
            searchPlaceholder={searchPlaceholder}
            minSearchLength={minSearchLength}
            debounceDelay={debounceDelay}
            {...rest}
            optionSlots={{
                ...optionSlots,
                fullscreen:
                    optionSlots?.fullscreen ??
                    ((item) => {
                        return (
                            <PickerOptionCard
                                title={`Заказ ${item.Num}`}
                                details={[
                                    { label: "Короткий номер", value: item.ShortNum },
                                    { label: "Дата", value: item.OrderDate },
                                ]}
                            />
                        );
                    }),
            }}
        />
    );
}
